import { render, staticRenderFns } from "./NotificationConfigScreen.vue?vue&type=template&id=78c9d038&"
import script from "./NotificationConfigScreen.vue?vue&type=script&lang=ts&"
export * from "./NotificationConfigScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports